<template>
  <a-select
    :value="value"
    :show-search="showSearch"
    :allow-clear="allowClear"
    :mode="mode || undefined"
    :placeholder="placeholder"
    :disabled="disabled"
    option-filter-prop="title"
    @change="onChange"
    :virtual="false"

  >
  <template  v-for="item in options">
    <a-select-option
      v-if="!hideArray.includes(item.valCode)"
      :key="item.valCode"
      :value="item.valCode"
      :title="item.valName"
      :disabled="disableArray.includes(item.valCode) || isOptionDisabled(item.valCode)"
    >
      {{ item.valName }}
    </a-select-option>
  </template>
    
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref, watch } from "vue";
import { DictValRecord } from "@/views/data-dict/dict/dict.interface";
import { DictService } from "@/views/data-dict/dict/dict.service";

type IValue = string[] | string | undefined;
type ISelectMode = undefined | "" | "multiple" | "tags" | "combobox";

/**
 * 全局组件: 字段选择器
 *
 * 使用方式:
 * <tenant-dict-select v-model="formRef.dictCode" code="sex"></tenant-dict-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "TenantDictSelect",
  props: {
    code: {
      type: String,
      required: true,
    },
    value: {
      type: [Array, String] as PropType<IValue>,
      default: undefined,
    },
    mode: {
      type: String as PropType<ISelectMode>,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableArray: {
      type: Array,
      default: () => [],
    },
    hideArray: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    maxCount: {
      type: Number,
      default: 0,
    },
  },
  emits: ["update:value", "change","update:list"],
  setup(props, { emit }) {
    const options = ref<DictValRecord[]>([]);

    const isOptionDisabled = (optionValue: string) => {
      if (!props.maxCount || props.mode !== 'multiple') return false;
      if (!Array.isArray(props.value)) return false;
      if (props.value.length >= props.maxCount) {
        return !props.value.includes(optionValue);
      }
      return false;
    };

    const onChange = (code) => {
      if (props.maxCount > 0 && props.mode === 'multiple' && Array.isArray(code) && code.length > props.maxCount) {
        code = code.slice(0, props.maxCount);
      }
      emit("update:value", code);
      emit("change", code);
    };

    watch(
      () => props.code,
      async (n) => {
        if (n && n.length > 0) {
          options.value = await DictService.fetchOptionsByDictCode(props.code);
          emit("update:list",options.value)
        }
      },
      { immediate: true }
    );
    return {
      options,
      isOptionDisabled,
      onChange,
    };
  },
});
</script>
